export const urlPrefix = '/';

export const routes = {
    main: `${urlPrefix}`,
    about: `${urlPrefix}about-us`,
    contact: `${urlPrefix}request-demo`,
    linkedin: `${urlPrefix}linkedin`,
    pendingOffers: `${urlPrefix}offers/pending`,
    acceptedOffers: `${urlPrefix}offers/accepted`,
    onboardedOffers: `${urlPrefix}offers/onboarded`,
    ghostedOffers: `${urlPrefix}offers/ghosted`,
    declinedOffers: `${urlPrefix}offers/declined`,
    retractedOffers: `${urlPrefix}offers/retracted`,
    rejectedOffers: `${urlPrefix}offers/rejected`,
    expiredOffers: `${urlPrefix}offers/expired`,
    candidates: `${urlPrefix}candidates`,
    // candidate: `${urlPrefix}candidate/priv/:first-:last-:id`,
    candidate: `${urlPrefix}candidate/priv/:privateSlug`,
    // company: `${urlPrefix}company/priv/:name-:id`,
    company: `${urlPrefix}company/priv/:privateSlug`,
    companies: `${urlPrefix}companies`,
    invitations: `${urlPrefix}invitations`,
    myCompany: `${urlPrefix}my-company`,
    accountSettings: `${urlPrefix}account-settings`,
    myProfile: `${urlPrefix}my-profile`,
    editMyProfile: `${urlPrefix}edit-my-profile`,
    releaseOffer: `${urlPrefix}release-offer`,
    employees: `${urlPrefix}employees`,
    document: `${urlPrefix}document/:id`,
    legal: `${urlPrefix}legal`,
    terms: `${urlPrefix}legal/terms`,
    privacy: `${urlPrefix}legal/privacy`,
    faq: `${urlPrefix}legal/faq`,
    dashboard: `${urlPrefix}dashboard`,
    submittedReview: `${urlPrefix}submitted-review`,
    offers: `${urlPrefix}offers`,
    signinSignup: `${urlPrefix}registration/social`,
    signUp: `${urlPrefix}signup`,
    verification: `${urlPrefix}registration/verification`,
    employervideo: `${urlPrefix}employer`,
    registrationProfile: `${urlPrefix}employer-registration`,
    webinar1: `${urlPrefix}webinars/no-more-candidate-backouts`,
    webinar2: `${urlPrefix}webinars/uniting-hrs-to-eliminate-candidate-ghosting`,
    webinar3: `${urlPrefix}webinars/say-goodbye-to-candidate-ghosting!!-offerx`,
    webinar4: `${urlPrefix}webinars/say-goodbye-to-candidate-backouts!!`,
    webinar5: `${urlPrefix}webinars/prevent-candidate-backouts-and-surprise-exits`,
    webinar6: `${urlPrefix}webinars/mastering-recruitment`,
    webinar7: `${urlPrefix}webinars/no-more-candidate-backouts-and-surprise-exits`,
    webinar8: `${urlPrefix}webinars/eliminate-candidate-backouts-and-unexpected-exits`,
    webinar9: `${urlPrefix}webinars/frustrated-by-candidate-backouts-and-unexpected-exits`,
    webinar10: `${urlPrefix}webinars/stop-getting-ghosted`,
    webinar11: `${urlPrefix}webinars/stop-losing-candidates`,
    webinars: `${urlPrefix}webinars`,
    podCast: `${urlPrefix}podcast`,
    verifyCompanyLead: `${urlPrefix}verify`,
    apiDoc: `${urlPrefix}documentation`,
    // pricing: `${urlPrefix}registration/pricing`
    verifyScreenXSignIn: `${urlPrefix}registration/screenX-OfferX-SignIn`,
    hrms: `${urlPrefix}api-integrate`,
    apiIntegrate: `${urlPrefix}integrate`,
    codeSnippet: `${urlPrefix}code-snippet`,
    successStories: `${urlPrefix}success-stories`,
    story1: `${urlPrefix}success-story-ULearn`,
    // story2: `${urlPrefix}success-story-Inspiring-Touch`,
    story3: `${urlPrefix}success-story-Implantaire`,
    claimProcess: `${urlPrefix}claim-account`,
    unclaimed: `${urlPrefix}unclaimed-candidate`,
    rewards: `${urlPrefix}all-rewards`,
    subscriptionPlans: `${urlPrefix}subscription-plans`,
    earnFreeSubscription: `${urlPrefix}earn-free-subscription`,
    blogLanding: `${urlPrefix}blogs`,
    blog1: `${urlPrefix}A-Step-by-Step-Guide-To-Effortless-Onboarding`,
    blog2: `${urlPrefix}Whats-New-in-OfferX`,
    blog3: `${urlPrefix}Everything-You-Need-to-Know-About-Offboarding`,
    blog4: `${urlPrefix}Recruitment-Challenges-Are-Creating-a-Trust-Crisis-in-Hiring`,
    dataPunchLanding: `${urlPrefix}offer-data-punch`,
    candidatePublicSearch: `${urlPrefix}candidate/pub/:publicSlug`,
    companyPublicSearch: `${urlPrefix}company/pub/:publicSlug`,
    candPrivatePage: `${urlPrefix}candidate-private-page`,
    compPrivatePage: `${urlPrefix}company-private-page`,
    aprilEvent: `${urlPrefix}april-event`,
    mayEvent: `${urlPrefix}may-event`,
    augustEvent: `${urlPrefix}augustevent`,
    octoberEvent: `${urlPrefix}talent-forum`,
    candClaimRoute: `${urlPrefix}candidate-claim`,
    releasedContract: `${urlPrefix}released-contract`,
    receivedContract: `${urlPrefix}received-contract`,
    marketplaceIntegrations: `${urlPrefix}marketplace`,
    userMarketplaceIntegrations: `${urlPrefix}marketplace-user`,
    marketplaceCandidateSignUp: `${urlPrefix}marketplace-signup`,
    keka: `${urlPrefix}keka`,
};
